module.exports = __webpack_public_path__ + "media/images/number_14-ad925a055e7f4263b1e447954fe91dd6.png";